import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {en_GB} from "./en_GB";

i18n.use(initReactI18next).init({
    lng: "en-GB",
    debug: true,
    resources: {
        "en-GB": en_GB,
    },
});

export {default} from "i18next";
